import styled from '@emotion/styled';

interface StyledTbmMonitoringProps {
  scrollY?: number;
}

export const StyledTbmMonitoring = styled.div<StyledTbmMonitoringProps>`
  display: flex;
  flex-direction: row;
  height: 100%;

  .chart-dashboard {
    height: ${({ scrollY }) => `${scrollY}px`};
  }

  .left-content {
    flex-grow: 1;
    width: 550px;
    margin-right: 16px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
  }

  .monitoring-wrapper {
    flex-grow: 2;
    width: 100%;
    height: ${({ scrollY }) => `${scrollY}px`};
    background-color: black;
  }

  .right-content {
    flex-grow: 1;
  }
`;